import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Header from '../../components/Header';
import Title from '../../components/Title';
import Text from '../../components/Text';
import Line from '../../components/Line';
import List from '../../components/List';
import Tabs from '../../components/Tabs';
import Textarea from '../../components/Textarea';
import Actions from '../../components/Actions';
import Img from '../../components/Img';
import MobileMenuHeader from '../../components/MobileMenuHeader';
import { updateCollectionById } from '../../utils/helpers';

export default function Solutions(props) {
  const {
    nextClickHandler,
    menuItems,
    selectComponent,
    componentIndex,
    rules,
    backPath,
    locales,
    locales: {
      common,
      ideation: {
        name,
        tabs: { items, yourProblem, problem, solution },
        solutions: { header, title, text, list, tabs, actions },
        caseStudies,
      },
    },
  } = props;
  const {
    ideation: {
      idea: {
        data: { ideas },
      },
    },
  } = useSelector((state) => state);
  const {
    ideation: { updateIdeaData },
  } = useDispatch();

  return (
    <section className="bmc-page" aria-label={header}>
      <Header
        title={header}
        subtitle={name}
        icon="icon-VP"
        locales={locales}
        componentIndex={componentIndex}
        className="bmc-page-header--blue"
        menuItems={menuItems}
        onMenuItemClick={selectComponent}
        rules={rules}
        backPath={backPath}
        mobileMenuHeader={
          <MobileMenuHeader icon="ideationActive" title={name} color="blue" />
        }
      />

      <Text>{[text[0]]}</Text>

      <Title text={title[0]} align="left" />

      <List items={list} icons={['sun']} />

      <Line />

      <h2 className="bmc-page-title">
        <span className="bmc-page-title--blue">{title[1]}</span> {title[2]}
      </h2>

      <Text align="center">{[text[1]]}</Text>

      <Tabs
        tabs={items}
        className="margin-wide-40-lg margin-top-60 bmc-page-tabs--blue"
      >
        <div className="ideation-solutions">
          {ideas.map((idea, index) => (
            <div className="ideation-solutions-item" key={index}>
              <div className="ideation-solutions-item-image">
                <Img src={idea.url} aspectRatio={1} />
              </div>

              <div className="ideation-solutions-item-text">
                <div className="ideation-solutions-item-title">
                  {yourProblem}
                </div>
                {idea.problem}
              </div>

              <Textarea
                value={idea.solution || ''}
                delay={300}
                onChange={(e) =>
                  updateIdeaData({
                    ideas: updateCollectionById(ideas, idea.id, {
                      solution: e.target.value,
                    }),
                  })
                }
                placeholder={tabs.addSolution}
                className="bmc-form-textarea"
              />
            </div>
          ))}
        </div>

        <div className="ideation-solutions">
          {caseStudies.map((idea, index) => (
            <div className="ideation-solutions-item" key={index}>
              <div className="ideation-solutions-item-image">
                <Img src={idea.url} aspectRatio={1} />
              </div>

              <div className="ideation-solutions-item-text">
                <div className="ideation-solutions-item-title">{problem}</div>
                {idea.problem}
              </div>

              <div className="ideation-solutions-item-text">
                <div className="ideation-solutions-item-title">{solution}</div>
                {idea.solution}
              </div>
            </div>
          ))}
        </div>
      </Tabs>

      <Actions
        nextClickHandler={nextClickHandler}
        buttonName={common.next}
        tooltipIfDisabled={actions.tooltipIfDisabled}
      />
    </section>
  );
}
